export function PauseRadiusIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="5" y="5" width="3.33333" height="10" rx="0.833333" fill="currentColor" />
      <rect x="11.6667" y="5" width="3.33333" height="10" rx="0.833333" fill="currentColor" />
    </svg>
  );
}

PauseRadiusIcon.displayName = 'PauseRadiusIcon';
